export class FeedbackPopupData {
    constructor(public learningPackageId: string,
                public questionId?: string) {
    }
}
